export default __webpack_public_path__ + "static/media/mode-535.59f13ee8.svg";